module.exports = __webpack_public_path__ + "static/img/04.3f3a6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/04.png
// module id = qp3k
// module chunks = 1